import React from 'react';
import { useLang } from '@/i18n/LanguageContext';
import PageContainer from '@/components/PageContainer';
import PageHeader from '@/components/PageHeader';
import { Zap, ShieldCheck, Heart, Lightbulb } from 'lucide-react';

const ICONS = [Zap, ShieldCheck, Heart, Lightbulb];

export default function Valeurs() {
  const { t } = useLang();
  const v = t.valeurs;

  return (
    <PageContainer>
      <PageHeader kicker={v.kicker} title={v.title} />

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
        {v.items.map((item, i) => {
          const Icon = ICONS[i];
          return (
            <article
              key={i}
              className="group relative bg-white p-8 lg:p-10 border border-[var(--color-taupe)]/20 hover:border-[var(--color-gold)] transition-all duration-500 overflow-hidden"
              data-testid={`value-${i}`}
            >
              <div className="absolute top-0 left-0 h-1 w-12 bg-[var(--color-gold)] group-hover:w-full transition-all duration-700" />
              <span className="absolute top-6 right-6 font-display text-5xl text-[var(--color-gold)]/20 group-hover:text-[var(--color-gold)]/40 transition-colors">
                0{i + 1}
              </span>
              <div className="w-12 h-12 flex items-center justify-center bg-navy text-[var(--color-gold)] mb-6">
                <Icon size={22} />
              </div>
              <h3 className="font-display text-2xl md:text-3xl text-navy mb-3">{item.title}</h3>
              <p className="text-navy/75 text-[15.5px] leading-relaxed">{item.text}</p>
            </article>
          );
        })}
      </div>
    </PageContainer>
  );
}
